var map = {
	"./AttendanceReport.png": "75f9",
	"./CompanyCalendar.png": "32f6",
	"./DocumentCheclist.png": "2e2d",
	"./Documents.png": "dafb",
	"./Documents1.png": "beff",
	"./Excel_Icon.png": "a2dd",
	"./ForgotPunch.png": "a841",
	"./HolidayList.png": "853b",
	"./Intranet_Head.png": "8e40",
	"./Intranet_Head2.png": "e9d5",
	"./Intranet_Head2_1.png": "7864",
	"./Intranet_Head2_2.png": "4250",
	"./Intranet_Head2_2_2.png": "8efe",
	"./Intranet_Head2__3.png": "32ff",
	"./Intranet_Head_old.png": "1868",
	"./Intranet_Head_old_2.png": "b905",
	"./LFC-24.png": "328d",
	"./LeaveBalance.png": "41a4",
	"./LeaveMain.png": "e8e4",
	"./ManageRedCross.png": "d932",
	"./Menu.png": "1cac",
	"./MenuRole.png": "5a30",
	"./OnDuty.png": "e9be",
	"./OnDutyException.png": "1e0b",
	"./PDF.png": "1d8f",
	"./Permissions.png": "d5fe",
	"./RoleMenu.png": "a6fc",
	"./Roles.png": "3003",
	"./ShiftOverride.png": "36d9",
	"./ShortLeave.png": "27f8",
	"./StaffDocuments.png": "32f65",
	"./TimeInOut.png": "ceac",
	"./User-Management.png": "e2b3",
	"./UserRole.png": "6d19",
	"./ViewHistory.png": "882e",
	"./accounting.png": "4c2d",
	"./activity.png": "778a",
	"./administrator.png": "ee78",
	"./allocate-icon-small.png": "6267",
	"./attendance.png": "61ab",
	"./attendancereport1.png": "aaad",
	"./awardmaster.png": "50b2",
	"./bg-banner.jpg": "9d18",
	"./bg-globalNav3.jpg": "cbd2",
	"./bluebook.png": "b8a9",
	"./body-bg-old.jpg": "6585",
	"./body-bg.jpg": "2dc6",
	"./calendar.png": "10b5",
	"./changes.png": "c0af",
	"./chart-1.jpg": "19ea",
	"./chart-2.jpg": "0f35",
	"./check-o.png": "df60",
	"./check-old.png": "adee",
	"./check.png": "722d",
	"./checklist.png": "2149",
	"./comment.png": "b46c",
	"./courses.png": "91d9",
	"./crm.png": "b89b",
	"./cross-o.png": "92ff",
	"./cross.png": "825b",
	"./cross_old.png": "3cb1",
	"./customize.png": "da2b",
	"./customize1.png": "e086",
	"./del-1.png": "1921",
	"./del.png": "6e30",
	"./delete.png": "b32a",
	"./demon.png": "c466",
	"./designation.png": "9ffa",
	"./doctype.png": "0ff5",
	"./documentcategory.png": "d1d7",
	"./dropdown.png": "2f53",
	"./edit-1.png": "6075",
	"./edit.png": "8170",
	"./event.png": "2c4a",
	"./folder.png": "ee83",
	"./generator.png": "acc4",
	"./glass.png": "d8e5",
	"./home.png": "28ea",
	"./idea.png": "542e",
	"./industry-stats.png": "105a",
	"./info-1.png": "2c93",
	"./info.png": "7c12",
	"./intranet.png": "8626",
	"./job-vacancy.png": "050e",
	"./jobs.png": "8290",
	"./leave.png": "79d9",
	"./letter.png": "e245",
	"./lira-logo-1-1.png": "f940",
	"./lira-logo.png": "da00",
	"./lock.png": "4f99",
	"./login-bg-mob.jpg": "94fe",
	"./login-bg-v1-blue.jpg": "12b1",
	"./login-bg-v1-july.jpg": "feef",
	"./login-bg-v1-latest.jpg": "df63",
	"./login-bg-v1.jpg": "90a8",
	"./login-bg-v1_27June.jpg": "409e",
	"./login-bg-v2.jpg": "bce3",
	"./login-bg-v4.jpg": "d0ce",
	"./login-bg.jpg": "9ba7",
	"./logout.png": "735a",
	"./managecontent.png": "3973",
	"./master-data.png": "d29d",
	"./master.png": "8999",
	"./message.png": "9686c",
	"./mobile.png": "58b8",
	"./mobile_old.png": "f844",
	"./multi-extend.png": "4f3d",
	"./my-profile.png": "4aa7",
	"./netedge-logo-new.png": "dabf",
	"./netedge-logo-white.png": "f163",
	"./netedge-logo.png": "1708",
	"./new.gif": "676b",
	"./next.png": "0f66",
	"./personal-details.png": "caef",
	"./personal-information.png": "866b",
	"./plus-1.png": "6cc9",
	"./print.png": "4c60",
	"./profile-sprite-old.png": "bd88",
	"./profile-sprite.png": "f873",
	"./ques.png": "f0cf",
	"./releasenotes.png": "aa80",
	"./report.png": "0a82",
	"./rewards.png": "88ef",
	"./separation.png": "b4ab",
	"./settings.png": "9d6a",
	"./shiftmaster.png": "03ca",
	"./sprite-icon-new.png": "bb6b",
	"./sprite-icon.png": "467e",
	"./staffImage.jpg": "9519",
	"./staff_shift.png": "785d",
	"./subordinate-attendance.png": "7d76",
	"./successfull-1.png": "55cb",
	"./successfull.jpg": "ab88",
	"./successfull.png": "057b",
	"./team.png": "d582",
	"./teamprofile.png": "7910",
	"./timein.png": "e64c",
	"./timeout.png": "329b",
	"./tip.png": "a79c",
	"./to-do.png": "f364",
	"./trainer.png": "7b5c",
	"./upload.png": "894f",
	"./view.png": "7f61",
	"./vtiger-data.png": "bc11",
	"./wel-bg1.jpg": "b325",
	"./workplace.png": "c5ce"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";